var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3319,
    height: 1121,
    viewBox: "0 0 3319 1121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.501 816.861C320.689 807.753 316.81 799.6 311.862 792.403C307.026 785.094 301.179 778.852 294.319 773.68C287.572 768.507 279.813 764.627 271.042 762.041C262.27 759.342 252.712 757.993 242.366 757.993C223.811 757.993 207.281 762.659 192.775 771.993C178.268 781.326 166.854 795.046 158.533 813.151C150.324 831.143 146.219 853.071 146.219 878.935C146.219 905.024 150.324 927.121 158.533 945.226C166.742 963.331 178.156 977.107 192.775 986.553C207.393 995.886 224.374 1000.55 243.716 1000.55C261.258 1000.55 276.439 997.179 289.259 990.432C302.191 983.685 312.143 974.127 319.115 961.757C326.087 949.274 329.573 934.656 329.573 917.9L343.742 920.093H249.957V871.176H390.129V912.671C390.129 942.246 383.832 967.829 371.237 989.42C358.642 1011.01 341.324 1027.65 319.284 1039.35C297.243 1050.93 271.941 1056.72 243.378 1056.72C211.554 1056.72 183.61 1049.58 159.545 1035.3C135.592 1020.91 116.869 1000.5 103.375 974.07C89.9928 947.531 83.3018 916.045 83.3018 879.61C83.3018 851.722 87.2377 826.814 95.1094 804.885C103.094 782.957 114.226 764.346 128.508 749.053C142.789 733.647 159.545 721.951 178.774 713.967C198.004 705.871 218.92 701.822 241.523 701.822C260.64 701.822 278.463 704.634 294.994 710.256C311.525 715.767 326.2 723.638 339.019 733.871C351.951 744.105 362.578 756.25 370.9 770.306C379.221 784.363 384.675 799.881 387.261 816.861H323.501ZM447.944 1052V792.909H507.15V836.091H509.849C514.572 821.135 522.668 809.608 534.139 801.512C545.721 793.303 558.934 789.198 573.778 789.198C577.152 789.198 580.919 789.367 585.08 789.704C589.353 789.929 592.895 790.323 595.706 790.885V847.055C593.12 846.155 589.015 845.368 583.393 844.694C577.883 843.906 572.541 843.513 567.368 843.513C556.236 843.513 546.227 845.931 537.343 850.766C528.572 855.489 521.656 862.067 516.596 870.501C511.536 878.935 509.005 888.663 509.005 899.683V1052H447.944ZM706.191 1057.23C689.773 1057.23 674.986 1054.31 661.829 1048.46C648.784 1042.5 638.438 1033.73 630.792 1022.14C623.257 1010.56 619.49 996.28 619.49 979.299C619.49 964.681 622.189 952.592 627.587 943.033C632.984 933.475 640.35 925.828 649.684 920.093C659.017 914.358 669.532 910.029 681.227 907.105C693.034 904.069 705.235 901.876 717.83 900.526C733.011 898.952 745.325 897.546 754.771 896.309C764.217 894.96 771.076 892.936 775.35 890.237C779.735 887.426 781.928 883.096 781.928 877.249V876.237C781.928 863.529 778.161 853.69 770.627 846.718C763.092 839.746 752.241 836.26 738.071 836.26C723.115 836.26 711.252 839.521 702.48 846.043C693.821 852.565 687.974 860.268 684.938 869.152L627.924 861.055C632.422 845.312 639.844 832.155 650.19 821.585C660.535 810.901 673.186 802.917 688.142 797.632C703.099 792.234 719.629 789.536 737.734 789.536C750.216 789.536 762.642 790.997 775.012 793.921C787.382 796.845 798.683 801.68 808.917 808.428C819.15 815.062 827.359 824.115 833.544 835.585C839.841 847.055 842.99 861.393 842.99 878.598V1052H784.29V1016.41H782.265C778.554 1023.61 773.325 1030.35 766.578 1036.65C759.944 1042.84 751.566 1047.84 741.445 1051.66C731.437 1055.37 719.685 1057.23 706.191 1057.23ZM722.047 1012.36C734.304 1012.36 744.931 1009.94 753.927 1005.11C762.924 1000.16 769.839 993.637 774.675 985.54C779.623 977.444 782.097 968.616 782.097 959.058V928.527C780.185 930.101 776.924 931.563 772.313 932.913C767.815 934.262 762.755 935.443 757.132 936.455C751.51 937.467 745.943 938.367 740.433 939.154C734.923 939.941 730.144 940.616 726.095 941.178C716.987 942.415 708.834 944.439 701.637 947.25C694.44 950.062 688.761 953.998 684.6 959.058C680.439 964.006 678.359 970.416 678.359 978.287C678.359 989.533 682.464 998.023 690.673 1003.76C698.882 1009.49 709.34 1012.36 722.047 1012.36ZM1000.54 1056.55C980.182 1056.55 961.965 1051.33 945.884 1040.87C929.803 1030.41 917.096 1015.23 907.763 995.324C898.429 975.42 893.762 951.242 893.762 922.792C893.762 894.004 898.485 869.714 907.931 849.923C917.49 830.018 930.366 815.006 946.559 804.885C962.752 794.652 980.801 789.536 1000.7 789.536C1015.89 789.536 1028.37 792.122 1038.15 797.295C1047.93 802.355 1055.69 808.484 1061.43 815.681C1067.16 822.765 1071.61 829.456 1074.75 835.754H1077.28V706.545H1138.52V1052H1078.47V1011.18H1074.75C1071.61 1017.48 1067.05 1024.17 1061.09 1031.25C1055.13 1038.22 1047.26 1044.18 1037.48 1049.13C1027.69 1054.08 1015.38 1056.55 1000.54 1056.55ZM1017.57 1006.46C1030.5 1006.46 1041.52 1002.97 1050.63 995.999C1059.74 988.914 1066.66 979.074 1071.38 966.48C1076.1 953.885 1078.47 939.21 1078.47 922.455C1078.47 905.699 1076.1 891.136 1071.38 878.767C1066.77 866.397 1059.91 856.782 1050.8 849.923C1041.81 843.063 1030.73 839.633 1017.57 839.633C1003.97 839.633 992.608 843.175 983.499 850.26C974.391 857.344 967.531 867.128 962.921 879.61C958.31 892.092 956.005 906.374 956.005 922.455C956.005 938.648 958.31 953.098 962.921 965.805C967.644 978.4 974.559 988.352 983.668 995.661C992.889 1002.86 1004.19 1006.46 1017.57 1006.46ZM1619.8 823.103H1556.71C1554.91 812.757 1551.6 803.592 1546.76 795.608C1541.93 787.511 1535.91 780.652 1528.71 775.029C1521.52 769.406 1513.31 765.189 1504.08 762.378C1494.98 759.454 1485.14 757.993 1474.57 757.993C1455.79 757.993 1439.14 762.716 1424.64 772.162C1410.13 781.495 1398.77 795.214 1390.56 813.319C1382.35 831.312 1378.25 853.296 1378.25 879.273C1378.25 905.699 1382.35 927.965 1390.56 946.07C1398.89 964.062 1410.24 977.669 1424.64 986.89C1439.14 995.999 1455.73 1000.55 1474.4 1000.55C1484.74 1000.55 1494.41 999.203 1503.41 996.505C1512.52 993.693 1520.67 989.589 1527.87 984.191C1535.18 978.793 1541.31 972.159 1546.25 964.287C1551.31 956.415 1554.8 947.419 1556.71 937.298L1619.8 937.636C1617.44 954.054 1612.32 969.46 1604.45 983.854C1596.69 998.248 1586.51 1010.95 1573.92 1021.98C1561.32 1032.88 1546.59 1041.43 1529.72 1047.61C1512.86 1053.69 1494.13 1056.72 1473.55 1056.72C1443.19 1056.72 1416.09 1049.69 1392.25 1035.64C1368.41 1021.58 1349.63 1001.28 1335.91 974.745C1322.19 948.206 1315.33 916.382 1315.33 879.273C1315.33 842.051 1322.25 810.227 1336.08 783.8C1349.91 757.262 1368.75 736.964 1392.59 722.907C1416.43 708.851 1443.42 701.822 1473.55 701.822C1492.78 701.822 1510.66 704.521 1527.19 709.919C1543.72 715.317 1558.46 723.245 1571.39 733.703C1584.32 744.048 1594.95 756.756 1603.27 771.824C1611.7 786.78 1617.21 803.873 1619.8 823.103ZM1787.42 1057.06C1762.12 1057.06 1740.19 1051.49 1721.64 1040.36C1703.08 1029.23 1688.69 1013.65 1678.46 993.637C1668.34 973.621 1663.28 950.23 1663.28 923.467C1663.28 896.703 1668.34 873.257 1678.46 853.127C1688.69 832.998 1703.08 817.368 1721.64 806.235C1740.19 795.102 1762.12 789.536 1787.42 789.536C1812.73 789.536 1834.65 795.102 1853.21 806.235C1871.76 817.368 1886.1 832.998 1896.22 853.127C1906.45 873.257 1911.57 896.703 1911.57 923.467C1911.57 950.23 1906.45 973.621 1896.22 993.637C1886.1 1013.65 1871.76 1029.23 1853.21 1040.36C1834.65 1051.49 1812.73 1057.06 1787.42 1057.06ZM1787.76 1008.14C1801.48 1008.14 1812.95 1004.38 1822.17 996.842C1831.39 989.195 1838.25 978.962 1842.75 966.142C1847.36 953.323 1849.67 939.041 1849.67 923.298C1849.67 907.442 1847.36 893.104 1842.75 880.285C1838.25 867.353 1831.39 857.063 1822.17 849.417C1812.95 841.77 1801.48 837.946 1787.76 837.946C1773.7 837.946 1762.01 841.77 1752.68 849.417C1743.45 857.063 1736.54 867.353 1731.93 880.285C1727.43 893.104 1725.18 907.442 1725.18 923.298C1725.18 939.041 1727.43 953.323 1731.93 966.142C1736.54 978.962 1743.45 989.195 1752.68 996.842C1762.01 1004.38 1773.7 1008.14 1787.76 1008.14ZM2024.46 900.189V1052H1963.4V792.909H2021.76V836.934H2024.8C2030.76 822.428 2040.26 810.902 2053.3 802.355C2066.46 793.809 2082.71 789.536 2102.05 789.536C2119.93 789.536 2135.51 793.359 2148.78 801.006C2162.16 808.652 2172.5 819.729 2179.81 834.235C2187.23 848.742 2190.89 866.341 2190.78 887.032V1052H2129.72V896.478C2129.72 879.16 2125.22 865.61 2116.22 855.826C2107.34 846.043 2095.02 841.151 2079.28 841.151C2068.6 841.151 2059.09 843.513 2050.77 848.236C2042.56 852.846 2036.1 859.537 2031.38 868.309C2026.76 877.08 2024.46 887.707 2024.46 900.189ZM2313.91 900.189V1052H2252.85V792.909H2311.21V836.934H2314.25C2320.21 822.428 2329.71 810.902 2342.76 802.355C2355.91 793.809 2372.16 789.536 2391.5 789.536C2409.38 789.536 2424.96 793.359 2438.23 801.006C2451.61 808.652 2461.96 819.729 2469.27 834.235C2476.69 848.742 2480.34 866.341 2480.23 887.032V1052H2419.17V896.478C2419.17 879.16 2414.67 865.61 2405.67 855.826C2396.79 846.043 2384.48 841.151 2368.73 841.151C2358.05 841.151 2348.55 843.513 2340.23 848.236C2332.02 852.846 2325.55 859.537 2320.83 868.309C2316.22 877.08 2313.91 887.707 2313.91 900.189ZM2657.01 1057.06C2631.03 1057.06 2608.59 1051.66 2589.7 1040.87C2570.92 1029.96 2556.47 1014.55 2546.35 994.649C2536.23 974.633 2531.17 951.074 2531.17 923.973C2531.17 897.321 2536.23 873.931 2546.35 853.802C2556.59 833.561 2570.87 817.817 2589.2 806.572C2607.53 795.214 2629.06 789.536 2653.8 789.536C2669.77 789.536 2684.84 792.122 2699.01 797.295C2713.29 802.355 2725.88 810.227 2736.79 820.91C2747.81 831.593 2756.47 845.2 2762.77 861.73C2769.06 878.148 2772.21 897.715 2772.21 920.43V939.154H2559.85V897.996H2713.68C2713.57 886.301 2711.04 875.899 2706.09 866.79C2701.14 857.569 2694.23 850.316 2685.34 845.031C2676.57 839.746 2666.34 837.103 2654.64 837.103C2642.16 837.103 2631.2 840.139 2621.75 846.212C2612.31 852.172 2604.94 860.043 2599.65 869.827C2594.48 879.498 2591.84 890.124 2591.73 901.707V937.636C2591.73 952.704 2594.48 965.636 2599.99 976.432C2605.5 987.115 2613.21 995.324 2623.1 1001.06C2633 1006.68 2644.58 1009.49 2657.85 1009.49C2666.73 1009.49 2674.77 1008.26 2681.97 1005.78C2689.17 1003.2 2695.41 999.428 2700.69 994.48C2705.98 989.533 2709.97 983.404 2712.67 976.094L2769.68 982.504C2766.08 997.573 2759.23 1010.73 2749.1 1021.98C2739.1 1033.11 2726.28 1041.77 2710.65 1047.95C2695.01 1054.02 2677.13 1057.06 2657.01 1057.06ZM2936.89 1057.06C2911.02 1057.06 2888.81 1051.38 2870.26 1040.02C2851.82 1028.67 2837.59 1012.98 2827.58 992.962C2817.69 972.833 2812.74 949.668 2812.74 923.467C2812.74 897.153 2817.8 873.931 2827.92 853.802C2838.04 833.561 2852.32 817.817 2870.76 806.572C2889.32 795.214 2911.25 789.536 2936.55 789.536C2957.58 789.536 2976.19 793.415 2992.38 801.174C3008.69 808.821 3021.68 819.673 3031.35 833.729C3041.02 847.674 3046.53 863.979 3047.88 882.646H2989.51C2987.15 870.164 2981.53 859.762 2972.65 851.441C2963.87 843.007 2952.12 838.79 2937.39 838.79C2924.91 838.79 2913.95 842.163 2904.5 848.91C2895.05 855.545 2887.69 865.104 2882.4 877.586C2877.23 890.068 2874.64 905.024 2874.64 922.455C2874.64 940.11 2877.23 955.291 2882.4 967.998C2887.58 980.593 2894.83 990.32 2904.16 997.179C2913.61 1003.93 2924.69 1007.3 2937.39 1007.3C2946.39 1007.3 2954.43 1005.61 2961.51 1002.24C2968.71 998.754 2974.73 993.75 2979.56 987.227C2984.4 980.705 2987.71 972.777 2989.51 963.444H3047.88C3046.42 981.773 3041.02 998.023 3031.68 1012.19C3022.35 1026.25 3009.64 1037.27 2993.56 1045.25C2977.48 1053.12 2958.59 1057.06 2936.89 1057.06ZM3227.39 792.909V840.139H3078.45V792.909H3227.39ZM3115.22 730.835H3176.28V974.07C3176.28 982.279 3177.52 988.577 3179.99 992.962C3182.58 997.236 3185.95 1000.16 3190.12 1001.73C3194.28 1003.31 3198.89 1004.1 3203.95 1004.1C3207.77 1004.1 3211.26 1003.81 3214.41 1003.25C3217.67 1002.69 3220.14 1002.18 3221.83 1001.73L3232.12 1049.47C3228.86 1050.59 3224.19 1051.83 3218.12 1053.18C3212.16 1054.53 3204.85 1055.32 3196.19 1055.54C3180.89 1055.99 3167.12 1053.69 3154.86 1048.63C3142.6 1043.45 3132.88 1035.47 3125.68 1024.67C3118.6 1013.88 3115.11 1000.38 3115.22 984.191V730.835Z",
    fill: "#202531"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 361.289,
    y1: 495.384,
    x2: 678.289,
    y2: 345.384,
    stroke: "#202531",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 361.289,
    y1: 495.384,
    x2: 678.289,
    y2: 345.384,
    stroke: "#202531",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 361.289,
    y1: 495.384,
    x2: 678.289,
    y2: 345.384,
    stroke: "#202531",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 903.765,
    y1: 588.196,
    x2: 1365.76,
    y2: 438.195,
    stroke: "#202531",
    strokeWidth: 8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 903.765,
    y1: 588.196,
    x2: 1365.76,
    y2: 438.195,
    stroke: "#202531",
    strokeWidth: 8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 903.765,
    y1: 588.196,
    x2: 1365.76,
    y2: 438.195,
    stroke: "#202531",
    strokeWidth: 8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1367.5,
    y1: 438.032,
    x2: 1818.5,
    y2: 495.032,
    stroke: "#202531",
    strokeWidth: 8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1367.5,
    y1: 438.032,
    x2: 1818.5,
    y2: 495.032,
    stroke: "#202531",
    strokeWidth: 8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1367.5,
    y1: 438.032,
    x2: 1818.5,
    y2: 495.032,
    stroke: "#202531",
    strokeWidth: 8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 674.532,
    y1: 345.036,
    x2: 1367.53,
    y2: 438.036,
    stroke: "#202531",
    strokeWidth: 8
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 674.532,
    y1: 345.036,
    x2: 1367.53,
    y2: 438.036,
    stroke: "#202531",
    strokeWidth: 8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 674.532,
    y1: 345.036,
    x2: 1367.53,
    y2: 438.036,
    stroke: "#202531",
    strokeWidth: 8
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1365.45,
    y1: 438.311,
    x2: 1945.45,
    y2: 195.311,
    stroke: "#202531",
    strokeWidth: 8
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1365.45,
    y1: 438.311,
    x2: 1945.45,
    y2: 195.311,
    stroke: "#202531",
    strokeWidth: 8
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1365.45,
    y1: 438.311,
    x2: 1945.45,
    y2: 195.311,
    stroke: "#202531",
    strokeWidth: 8
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1814.33,
    y1: 497.42,
    x2: 1943.33,
    y2: 197.42,
    stroke: "#202531",
    strokeWidth: 8
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 1814.33,
    y1: 497.42,
    x2: 1943.33,
    y2: 197.42,
    stroke: "#202531",
    strokeWidth: 8
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1814.33,
    y1: 497.42,
    x2: 1943.33,
    y2: 197.42,
    stroke: "#202531",
    strokeWidth: 8
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 2120.55,
    y1: 501.033,
    x2: 1943.55,
    y2: 201.033,
    stroke: "#202531",
    strokeWidth: 8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 2120.55,
    y1: 501.033,
    x2: 1943.55,
    y2: 201.033,
    stroke: "#202531",
    strokeWidth: 8
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 2120.55,
    y1: 501.033,
    x2: 1943.55,
    y2: 201.033,
    stroke: "#202531",
    strokeWidth: 8
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 2488.62,
    y1: 445.952,
    x2: 2124.62,
    y2: 502.952,
    stroke: "#202531",
    strokeWidth: 8
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 2488.62,
    y1: 445.952,
    x2: 2124.62,
    y2: 502.952,
    stroke: "#202531",
    strokeWidth: 8
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 2488.62,
    y1: 445.952,
    x2: 2124.62,
    y2: 502.952,
    stroke: "#202531",
    strokeWidth: 8
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1948.64,
    y1: 195.351,
    x2: 2489.64,
    y2: 438.351,
    stroke: "#202531",
    strokeWidth: 8
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 1948.64,
    y1: 195.351,
    x2: 2489.64,
    y2: 438.351,
    stroke: "#202531",
    strokeWidth: 8
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 1948.64,
    y1: 195.351,
    x2: 2489.64,
    y2: 438.351,
    stroke: "#202531",
    strokeWidth: 8
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 2732.72,
    y1: 219.929,
    x2: 2490.72,
    y2: 444.929,
    stroke: "#202531",
    strokeWidth: 8
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 2732.72,
    y1: 219.929,
    x2: 2490.72,
    y2: 444.929,
    stroke: "#202531",
    strokeWidth: 8
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 2732.72,
    y1: 219.929,
    x2: 2490.72,
    y2: 444.929,
    stroke: "#202531",
    strokeWidth: 8
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 2489.71,
    y1: 438.384,
    x2: 2806.71,
    y2: 588.384,
    stroke: "#202531",
    strokeWidth: 8
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 2489.71,
    y1: 438.384,
    x2: 2806.71,
    y2: 588.384,
    stroke: "#202531",
    strokeWidth: 8
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 2489.71,
    y1: 438.384,
    x2: 2806.71,
    y2: 588.384,
    stroke: "#202531",
    strokeWidth: 8
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 676.899,
    y1: 346.244,
    x2: 907.899,
    y2: 589.244,
    stroke: "#202531",
    strokeWidth: 8
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 676.899,
    y1: 346.244,
    x2: 907.899,
    y2: 589.244,
    stroke: "#202531",
    strokeWidth: 8
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 676.899,
    y1: 346.244,
    x2: 907.899,
    y2: 589.244,
    stroke: "#202531",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 349,
    r: 150,
    fill: "#E50C33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 363,
    cy: 499,
    r: 75,
    fill: "#FDA800"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 905,
    cy: 592,
    r: 75,
    fill: "#0196BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1367,
    cy: 442,
    r: 150,
    fill: "#FDA800"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1947,
    cy: 199,
    r: 150,
    fill: "#0196BF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1818,
    cy: 499,
    r: 75,
    fill: "#E50C33"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2488,
    cy: 442,
    r: 150,
    fill: "#E50C33"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2124,
    cy: 499,
    r: 75,
    fill: "#FDA800"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2730,
    cy: 217,
    r: 75,
    fill: "#FDA800"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2805,
    cy: 592,
    r: 75,
    fill: "#0196BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logoTransparent.eb6069cb3925da1c47aba998240b40e8.svg";
export { ForwardRef as ReactComponent };